import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetMonetateProducts, makeGetMonetateRecommendations, } from '../../redux/monetate/selectors/MonetateSelectors';
import { monetateActions } from '../../redux/monetate/actions/MonetateActions.creators';
import { ProductGroupPdpComparison } from '../../components/product-group-comparison/ProductGroupPdpComparison';
import { useAemConfig } from '@as-react/common-components';
import { useSuspenseQueries } from '@tanstack/react-query';
import { productQueries } from '@as-react/common-queries';
const getAllProductComparisonFeatures = (productsFeatures, initialProductsFeaturesRecord) => {
    const shouldSetProductsFeaturesRecord = productsFeatures.some(productFeature => productFeature.features && productFeature.features.length > 0);
    return shouldSetProductsFeaturesRecord
        ? productsFeatures.reduce((acc, productFeatures) => {
            if (productFeatures) {
                acc[productFeatures.productId] = productFeatures.features;
            }
            return acc;
        }, initialProductsFeaturesRecord)
        : initialProductsFeaturesRecord;
};
const ProductGroupPdpComparisonMonetateContainer = ({ actionId, productId, title, maxProductsSize, productsFeaturesRecord: initialProductsFeaturesRecord, currentProductHasFeatures, }) => {
    const { defaultRequestParams, servicesEndpoint, fictiveWebShop } = useAemConfig();
    const dispatch = useDispatch();
    const recommendations = useSelector(makeGetMonetateRecommendations(actionId));
    const products = useSelector(makeGetMonetateProducts(actionId));
    const { getComparisonFeatures } = productQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { isPending, data: productsFeatures } = useSuspenseQueries({
        queries: currentProductHasFeatures
            ? products.map(product => getComparisonFeatures({
                mainWebShopId: Number(fictiveWebShop),
                productId: product.productId,
            }))
            : [],
        combine: results => ({
            data: results.map(result => result.data),
            isPending: results.some(result => result.isPending),
        }),
    });
    useEffect(() => {
        if (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) {
            dispatch(monetateActions.fetchMonetateProducts({
                actionId,
                size: maxProductsSize,
                filterProductId: productId,
            }));
        }
    }, [recommendations]);
    if (!(products === null || products === void 0 ? void 0 : products.length) || isPending || !productsFeatures) {
        return null;
    }
    const productsFeaturesRecord = getAllProductComparisonFeatures(productsFeatures, initialProductsFeaturesRecord);
    return (_jsx(ProductGroupPdpComparison, { analyticsAreaName: "product-group-pdp-comparison-monetate", productGroupId: `product-group-pdp-comparison-monetate-${actionId}`, products: products, productsFeaturesRecord: productsFeaturesRecord, title: title, analyticsProductGroupName: `mon_${actionId}`, currentProductHasFeatures: currentProductHasFeatures }));
};
export default ProductGroupPdpComparisonMonetateContainer;
